import React, { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import Zoom from "@mui/material/Zoom";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";

export default function CustomFabs({ tabIndex, callback }) {
    const theme = useTheme();

    useEffect(() => {}, [tabIndex]);

    const fabs = [
        {
            color: "primary",
            icon: <AddIcon />,
            label: "Add",
        },
        {
            color: "secondary",
            icon: <AddIcon />,
            label: "Add",
        },
        {
            color: "success",
            icon: <AddIcon />,
            label: "Add",
        },
        {
            color: "#009688",
            icon: <AddIcon />,
            label: "Add",
        },
    ];

    const transitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen,
    };

    const handleClick = (index) => {
        callback(index);
    };

    return (
        <Box sx={{ position: "fixed", right: "20px", bottom: "80px", left: "auto", top: "auto" }}>
            {fabs.map((fab, index) => (
                <Zoom
                    key={fab.color}
                    in={tabIndex === index}
                    timeout={transitionDuration}
                    style={{
                        transitionDelay: `${tabIndex === index ? transitionDuration.exit : 0}ms`,
                    }}
                    unmountOnExit
                >
                    <Fab aria-label={fab.label} color={fab.color} onClick={() => handleClick(index)} style={{ backgroundColor: fab.color, color: "#FFF" }}>
                        {fab.icon}
                    </Fab>
                </Zoom>
            ))}
        </Box>
    );
}
